import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const errorStr = (error && error.message) || (error && error.toString()) || '';
    const chunkFailedPattern = /Loading chunk|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

    if (chunkFailedPattern.test(errorStr)) {
      console.warn('Chunk load error detected. Attempting to reload page...', error);
      
      const now = Date.now();
      const lastReload = sessionStorage.getItem('last-chunk-error-reload');
      
      // Prevent infinite reload loops if reload happens too frequently (within 10 seconds)
      if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
        sessionStorage.setItem('last-chunk-error-reload', now.toString());
        window.location.reload();
        return;
      } else {
        console.error('Repeated chunk load errors detected. Reload blocked to prevent loop.', error);
      }
    }

    // Default error handling behavior: log to console
    console.error(error);
  }
}
